const state = {
  tenDlcEnums: {},
  fetchingAllTenDlcEnums: false,
  errorFetchingAllTenDlcEnums: null,
  tenDlcEnumsAssociatedKey: '',
};

export default state;
